/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Segment, Grid, Divider, Header, List, Popup,
  Button, Icon, Dimmer, Loader
} from "semantic-ui-react";
import { connect } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ApexCharts from "apexcharts";
import ProblemCard from "components/ts-expert/ProblemCard";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import TsExpertReport from "components/ts-expert/TsExpertReport";
import Utils from "utilities/Utils";
import { solveProblemAction } from "actions/changeActiveItemActions";

const UtilsInstance = new Utils();

let dpWaveFormOptions = {
  series: [{ data: [] }],
  chart: {
    type: "line",
  },
  colors: [Constants.BLUE_HEX],
  markers: {
    size: 0
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: Strings.WAVE_FORM,
    align: "center",
    style: {
      fontSize: "14px",
      fontFamily: "Helvetica, Arial, sans-serif"
    }
  },
  stroke: {
    curve: "straight",
    width: 2
  },
  xaxis: {
    type: "numeric",
    title: {
      text: Strings.TIME_NS
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        cssClass: "apexcharts-xaxis-label",
      }
    }
  },
  yaxis: {
    min: -1,
    max: 4,
    tickAmount: 8,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(2) + " V";
      },
      style: {
        colors: [],
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: 400,
        cssClass: "apexcharts-yaxis-label",
      }
    },
    title: {
      text: Strings.VOLTAGE_V
    },
  },
  annotations: {
    position: "front",
    xaxis: []
  }
};

export class TSExpert extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      lastUpdate: new Date(),
      networkTag: "",
      segmentTag: "",
      uptime: "",
      startTime: "",
      problems: [],
      groupedProblems: {
        // Protocol
        "retries": [],
        "diagnostic": [],
        "fault": [],
        "missing": [],
        // Meio Fisico
        "attentionSignal": [],
        "badSignal": [],
        "capacitiveEffect": [],
        "noise": [],
        "errorFrame": [],
      },
      currentProblemType: "",
      currentProblemList: [],
      // The report
      report: "",
      isGenerateReportDimmerActive: false
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    // promissesArray.push(
    //   fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
    //     .then(res => res.json())
    //     .then(data => data)
    // );

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertWithWaves", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.startTime)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    const problems = [...resolvedPromisses[0]];

    this.setState({
      problems: problems,
      startTime: resolvedPromisses[1],
    }, () => {
      this.checkProblemsListSize();
      this.groupProblemsByType();
    });
  }

  retrieveTagAndUptimeData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
        .catch(() => ({ networkTag: "", uptime: 0 }))
    );

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
        .catch(() => ({ tag: "" }))
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      networkTag: resolvedPromisses[0].networkTag,
      uptime: this.formatToRelativeTime(resolvedPromisses[0].uptime),
      segmentTag: resolvedPromisses[1].tag,
    });
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + " ano" + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + " mês");
      }
      else {
        out.push(md + " meses");
      }
    }
    if (dd > 0) out.push(dd + " dia" + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + " hora" + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + " minuto" + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  checkProblemsListSize = () => {
    if (this.state.problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";
    }
    else {
      document.getElementById("problems-list").style.display = "none";
      document.getElementById("no-problem-detected-header").style.display = "block";
    }
  }

  groupProblemsByType = () => {
    let newGroupedProblems = {
      // Protocol
      "retries": [],
      "diagnostic": [],
      "fault": [],
      "errorFrame": [],
      "missing": [],
      // Meio Fisico
      "attentionSignal": [],
      "badSignal": [],
      "capacitiveEffect": [],
      "noise": []
    };

    for (let i = 0; i < this.state.problems.length; i++) {
      // Protocol
      if (this.state.problems[i].type === Constants.RETRIES_ERROR_TYPE) {
        newGroupedProblems.retries.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
        newGroupedProblems.diagnostic.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FAULT_ERROR_TYPE) {
        newGroupedProblems.fault.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.ERROR_FRAME_TYPE) {
        newGroupedProblems.errorFrame.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.MISSING_ERROR_TYPE) {
        newGroupedProblems.missing.push(this.state.problems[i]);
      }
      // Meio Fisico
      else if (this.state.problems[i].type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
        newGroupedProblems.attentionSignal.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
        newGroupedProblems.badSignal.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
        newGroupedProblems.capacitiveEffect.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.NOISE_PROBLEM_TYPE) {
        newGroupedProblems.noise.push(this.state.problems[i]);
      }
    }

    this.setState({ groupedProblems: newGroupedProblems });
  }

  // ------ Events List ------
  getListItem = (problemType, groupedProblemList) => {
    if (groupedProblemList.length > 0) {
      return (
        <List.Item>
          <List.Content floated='right' style={{ marginTop: "4px" }}>
            <Button
              size="tiny"
              circular
              color="teal"
              icon="chevron right"
              onClick={this.handleDetailsButtonClick(problemType, groupedProblemList)} />
          </List.Content>
          {this.getListContent(problemType)}
        </List.Item>
      );
    }
    else {
      return "";
    }
  }

  handleDetailsButtonClick = (problemType, groupedProblemList) => () => {
    this.setState({
      currentProblemType: problemType,
      currentProblemList: groupedProblemList
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "none";
      document.getElementById("task-details").style.display = "block";
    });
  }

  getListContent = (problemType) => {
    // Protocol
    if (problemType === Constants.RETRIES_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.RETRIES_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DIAGNOSTIC_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FAULT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.ERROR_FRAME_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.ERROR_FRAME_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.MISSING_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.MISSING_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    // Meio Fisico
    else if (problemType === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.ATTENTION_SIGNAL_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.BAD_SIGNAL_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.CAPACITIVE_EFFECT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.NOISE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.NOISE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
  }

  // ------ Actions ------
  getActions = () => {
    // Protocol
    if (this.state.currentProblemType === Constants.RETRIES_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.RETRIES_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.RETRIES_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.RETRIES_SUGGESTION_3}</li>
            <li>{Strings.RETRIES_SUGGESTION_4}</li>
            <ol type="i">
              <li>{Strings.RETRIES_SUGGESTION_5}</li>
              <li>{Strings.RETRIES_SUGGESTION_6}</li >
              <li>{Strings.RETRIES_SUGGESTION_7}</li>
              <li>{Strings.RETRIES_SUGGESTION_8}</li>
            </ol>
            <li>{Strings.RETRIES_SUGGESTION_10}</li>
            <li>{Strings.RETRIES_SUGGESTION_13}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DIAGNOSTIC_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.DIAGNOSTIC_SUGGESTION_2}
          </p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FAULT_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.FAULT_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.FAULT_SUGGESTION_3}</li>
            <li>{Strings.FAULT_SUGGESTION_4}</li>
            <li>{Strings.FAULT_SUGGESTION_5}</li>
            <li>{Strings.FAULT_SUGGESTION_6}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.ERROR_FRAME_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.ERROR_FRAME_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.ERROR_FRAME_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.ERROR_FRAME_SUGGESTION_3}</li>
            <li>{Strings.ERROR_FRAME_SUGGESTION_4}</li>
            <ol type="i">
              <li>{Strings.ERROR_FRAME_SUGGESTION_5}</li>
              <li>{Strings.ERROR_FRAME_SUGGESTION_6}</li >
              <li>{Strings.ERROR_FRAME_SUGGESTION_7}</li>
              <li>{Strings.ERROR_FRAME_SUGGESTION_8}</li>
            </ol>
            <li>{Strings.ERROR_FRAME_SUGGESTION_10}</li>
            <li>{Strings.ERROR_FRAME_SUGGESTION_13}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.MISSING_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.MISSING_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.MISSING_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.MISSING_SUGGESTION_3}</li>
            <li>{Strings.MISSING_SUGGESTION_4}</li>
          </ol>
        </Segment>
      );
    }
    // Meio Fisico
    else if (this.state.currentProblemType === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.ATTENTION_SIGNAL_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.ATTENTION_SIGNAL_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.ATTENTION_SIGNAL_SUGGESTION_3}</li>
            <li>{Strings.ATTENTION_SIGNAL_SUGGESTION_4}</li>
            <li>{Strings.ATTENTION_SIGNAL_SUGGESTION_5}</li>
          </ul>

          <p style={{ textAlign: "justify" }}>{Strings.ATTENTION_SIGNAL_SUGGESTION_6}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.BAD_SIGNAL_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.BAD_SIGNAL_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.BAD_SIGNAL_SUGGESTION_3}</li>
            <li>{Strings.BAD_SIGNAL_SUGGESTION_4}</li>
          </ul>

          <p style={{ textAlign: "justify" }}>{Strings.BAD_SIGNAL_SUGGESTION_8}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.CAPACITIVE_EFFECT_SUGGESTION_1}</Header>

          <ul>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_2}</li>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_3}</li>
          </ul>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.NOISE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.NOISE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.NOISE_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.NOISE_SUGGESTION_3}</li>
            <li>{Strings.NOISE_SUGGESTION_4}</li>
            <li>{Strings.NOISE_SUGGESTION_5}</li>
            <li>{Strings.NOISE_SUGGESTION_6}</li>
          </ul>

          <p style={{ textAlign: "justify" }}>{Strings.NOISE_SUGGESTION_7}</p>

        </Segment>
      );
    }
  }

  getProblemCards = () => {
    if (this.state.currentProblemList.length > 1) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem} />
            ))
          }
          <Button
            fluid
            color='green'
            onClick={this.handleBatchCheckButtonClick}>
            {Strings.BATCH_CHECK}
          </Button>
        </Segment>
      );
    }
    else {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem} />
            ))
          }
        </Segment>
      );
    }
  }

  handleCloseButtonClick = () => {
    this.setState({
      currentProblemType: "",
      currentProblemList: []
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "block";
      document.getElementById("task-details").style.display = "none";
    });
  }

  handleBatchCheckButtonClick = () => {
    let data = JSON.stringify({
      type: this.state.currentProblemType,
      problems: this.state.currentProblemList
    });

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "solveAllProblems_POST", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus2)
      .then(() => {
        alert(Strings.ALL_EVENTS_CHECKED_SUCCESS);

        // Mostre que não existem eventos
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      })
      .catch((error) => {
        let result = JSON.parse(error.message);

        let message = "";

        if (result.notSolved.length > 0) {

          message += this.getInitialErrorMessage(result.type) + "\n";

          for (let i = 0; i < result.notSolved.length; i++) {
            message += this.getErrorMessage(result.notSolved[i]);
          }

        }

        alert(message);

        // Feche a seção de solução
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      });
  }

  getInitialErrorMessage = (problemType) => {
    // Protocol
    if (problemType === Constants.RETRIES_ERROR_TYPE) {
      return Strings.RETRIES_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return Strings.DIAGNOSTIC_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return Strings.FAULT_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.MISSING_ERROR_TYPE) {
      return Strings.MISSING_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return "Não foi possível conferir os eventos dos seguintes dispositivos:";
    }
    else if (problemType === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return "Não foi possível conferir os eventos dos seguintes dispositivos:";
    }
    else if (problemType === Constants.ERROR_FRAME_TYPE) {
      return "Não foi possível conferir o evento";
    }
    else if (problemType === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return "Não foi possível conferir os eventos dos seguintes dispositivos:";
    }
    else if (problemType === Constants.NOISE_PROBLEM_TYPE) {
      return "Não foi possível conferir o evento, pois o TS Monitor DN ainda está detectando ruido.";
    }
    else {
      return "";
    }
  }

  getErrorMessage = (problem) => {
    // Protocol
    if (problem.type === Constants.RETRIES_ERROR_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else if (problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else if (problem.type === Constants.FAULT_ERROR_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else if (problem.type === Constants.MISSING_ERROR_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else if (problem.type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else if (problem.type === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else if (problem.type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else if (problem.type === Constants.NOISE_PROBLEM_TYPE) {
      return "• Endereço: " + problem.address + "\n";
    }
    else {
      return "";
    }
  }

  // ------ TS Expert Report ------
  generateTsExpertReport = () => {
    this.setState({ report: "" }, async () => {
      this.setGeneratingDimmerState(true);

      let promissesArray = [];

      // promissesArray.push(
      //   fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
      //     .then(res => res.json())
      //     .then(data => data)
      // );

      promissesArray.push(
        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertWithWaves", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
          .then(res => res.json())
          .then(data => data.uptime)
      );

      promissesArray.push(
        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
          .then(res => res.json())
          .then(data => data.tag)
      );


      promissesArray.push(
        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "config", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
          .then(res => res.json())
          .then(data => data.status)
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let problems = [...resolvedPromisses[0]];

      let reportGroupedProblems = {
        // Protocol
        "retries": [],
        "diagnostic": [],
        "fault": [],
        "errorFrame": [],
        "missing": [],
        // Meio Fisico
        "attentionSignal": [],
        "badSignal": [],
        "capacitiveEffect": [],
        "noise": [],
      };

      for (let i = 0; i < problems.length; i++) {
        // Protocol
        if (problems[i].type === Constants.RETRIES_ERROR_TYPE) {
          reportGroupedProblems.retries.push(problems[i]);
        }
        else if (problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
          reportGroupedProblems.diagnostic.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
          reportGroupedProblems.fault.push(problems[i]);
        }
        else if (problems[i].type === Constants.ERROR_FRAME_TYPE) {
          reportGroupedProblems.errorFrame.push(problems[i]);
        }
        else if (problems[i].type === Constants.MISSING_ERROR_TYPE) {
          reportGroupedProblems.missing.push(problems[i]);
        }
        // Meio Fisico
        else if (problems[i].type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
          reportGroupedProblems.attentionSignal.push(problems[i]);
        }
        else if (problems[i].type === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
          reportGroupedProblems.badSignal.push(problems[i]);
        }
        else if (problems[i].type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
          reportGroupedProblems.capacitiveEffect.push(problems[i]);
        }
        else if (problems[i].type === Constants.NOISE_PROBLEM_TYPE) {
          reportGroupedProblems.noise.push(problems[i]);
        }
      }

      let attentionSignalImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.attentionSignal);
      let badSignalImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.badSignal);
      let capacitiveEffectImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.capacitiveEffect);
      let noiseImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.noise);

      let monitorUptime = resolvedPromisses[1];
      let tag = resolvedPromisses[2];
      let configData = resolvedPromisses[3];
      let wifiStatus = resolvedPromisses[4];

      // Informações da rede WLAN
      let wifiConfigData = "";

      if (wifiStatus === Constants.CONNECTED_STATUS) {
        wifiConfigData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
          .then(res => res.json())
          .then(data => data);
      }
      else {
        wifiConfigData = {
          "wifiMode": "",
          "hiddenSSID": false,
          "wifiName": "",
          "wifiAddr": "",
          "wifiNetmask": "",
          "wifiGateway": "",
          "wifiDNS": "",
          "wifiPwd": ""
        };
      }

      this.setState({
        report:
          <TsExpertReport
            nowMillis={Date.now()}
            startTime={this.state.startTime}
            // Data Info
            uptime={monitorUptime}
            tag={tag}
            configData={configData}
            wifiConfigData={wifiConfigData}
            // Protocol
            retries={reportGroupedProblems.retries}
            diagnostic={reportGroupedProblems.diagnostic}
            fault={reportGroupedProblems.fault}
            errorFrame={reportGroupedProblems.errorFrame}
            missing={reportGroupedProblems.missing}
            // Meio Fisico
            attentionSignal={reportGroupedProblems.attentionSignal}
            attentionSignalImages={attentionSignalImages}
            badSignal={reportGroupedProblems.badSignal}
            badSignalImages={badSignalImages}
            capacitiveEffect={reportGroupedProblems.capacitiveEffect}
            capacitiveEffectImages={capacitiveEffectImages}
            noise={reportGroupedProblems.noise}
            noiseImages={noiseImages}
          />
      });
    });
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_LIST_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  getOscilloscopeImgURIs = async (groupedProblem) => {
    let imgURIs = [];

    // Only try to generate the images if the array is not empty
    if (groupedProblem.length > 0) {
      document.getElementById("chart").style.display = "block";

      // Render the chart
      let chart = new ApexCharts(document.querySelector("#chart"), dpWaveFormOptions);
      chart.render();

      for (let i = 0; i < groupedProblem.length; i++) {
        let imgURIObj = {
          "address": groupedProblem[i].address,
          "wave": "",
          "ntp": groupedProblem[i].ntp,
          "amplitude": groupedProblem[i].amplitude,
          "time": groupedProblem[i].time,
        };

        let options = {};

        if (groupedProblem[i].type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.BAD_SIGNAL_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.NOISE_PROBLEM_TYPE) {
          // First render the wave B - A to get its imgURI
          options = this.getFormatedDNOptions(groupedProblem[i].wave, dpWaveFormOptions);

          options = {
            ...options,
            colors: [Constants.BLUE_HEX],
            title: {
              text: Strings.WAVE_DN,
            },
            series: [
              { name: Strings.WAVE_DN, data: this.formatDNWaveTimes(groupedProblem[i].wave) }
            ]
          };

          chart.updateOptions(options, false, false, false);

          imgURIObj.wave = await chart.dataURI();
        }

        // Save both waves URIs
        imgURIs.push(imgURIObj);
      }

      document.getElementById("chart").style.display = "none";

      chart.destroy();

      return imgURIs;
    }
    else {
      return imgURIs;
    }
  }

  getFormatedDNOptions = (wave, dpOptions) => {
    let options = {};

    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_MS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }

    return options;
  }

  formatDNWaveTimes = (wave) => {
    if (!wave || wave.length === 0) {
      return wave;
    }

    const lastTime = wave[wave.length - 1][0];

    if (lastTime < 1000) {
      return wave.map(point => [...point]);
    }

    if (lastTime >= 1000 && lastTime < 1000000) {
      return wave.map(point => [point[0] / 1000, point[1]]);
    }

    return wave.map(point => [point[0] / 1000000, point[1]]);
  }

  // ------ TS Expert Modal ------
  retrieveData2 = async () => {
    let promissesArray = [];

    // promissesArray.push(
    //   fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
    //     .then(res => res.json())
    //     .then(data => data)
    // );

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertWithWaves", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.startTime)
    );

    let resolvedPromisses = await Promise.all(promissesArray);
    let problems = [...resolvedPromisses[0]];
    let startTime = resolvedPromisses[1];

    if (problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";

      let newGroupedProblems = {
        // Protocol
        "retries": [],
        "diagnostic": [],
        "fault": [],
        "errorFrame": [],
        "missing": [],
        // Meio Fisico
        "attentionSignal": [],
        "badSignal": [],
        "capacitiveEffect": [],
        "noise": [],
      };

      for (let i = 0; i < problems.length; i++) {
        // Protocol
        if (problems[i].type === Constants.RETRIES_ERROR_TYPE) {
          newGroupedProblems.retries.push(problems[i]);
        }
        else if (problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
          newGroupedProblems.diagnostic.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
          newGroupedProblems.fault.push(problems[i]);
        }
        else if (problems[i].type === Constants.ERROR_FRAME_TYPE) {
          newGroupedProblems.errorFrame.push(problems[i]);
        }
        else if (problems[i].type === Constants.MISSING_ERROR_TYPE) {
          newGroupedProblems.missing.push(problems[i]);
        }
        // Meio Fisico
        else if (problems[i].type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
          newGroupedProblems.attentionSignal.push(problems[i]);
        }
        else if (problems[i].type === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
          newGroupedProblems.badSignal.push(problems[i]);
        }
        else if (problems[i].type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
          newGroupedProblems.capacitiveEffect.push(problems[i]);
        }
        else if (problems[i].type === Constants.NOISE_PROBLEM_TYPE) {
          newGroupedProblems.noise.push(problems[i]);
        }
      }

      let currentProblemsList = this.getCurrentProblemsList(newGroupedProblems);

      if (currentProblemsList.length > 0) {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: this.state.currentProblemType,
          currentProblemList: currentProblemsList,
          startTime: startTime
        });
      }
      else {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: "",
          currentProblemList: [],
          startTime: startTime,
        }, () => {
          document.getElementById("no-task-selected-header").style.display = "block";
          document.getElementById("task-details").style.display = "none";
        });
      }
    }
    else {
      this.setState({
        nowMillis: Date.now(),
        lastUpdate: new Date(),
        problems: [],
        groupedProblems: {
          // Protocol
          "retries": [],
          "diagnostic": [],
          "fault": [],
          "errorFrame": [],
          "missing": [],
          // Meio Fisico
          "attentionSignal": [],
          "badSignal": [],
          "capacitiveEffect": [],
          "noise": []
        },
        currentProblemType: "",
        currentProblemList: [],
        startTime: startTime,
      }, () => {
        document.getElementById("problems-list").style.display = "none";
        document.getElementById("no-problem-detected-header").style.display = "block";
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";
      });
    }
  }

  getCurrentProblemsList = (groupedProblems) => {
    // Protocol
    if (this.state.currentProblemType === Constants.RETRIES_ERROR_TYPE) {
      return groupedProblems.retries;
    }
    else if (this.state.currentProblemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return groupedProblems.diagnostic;
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return groupedProblems.fault;
    }
    else if (this.state.currentProblemType === Constants.ERROR_FRAME_TYPE) {
      return groupedProblems.errorFrame;
    }
    else if (this.state.currentProblemType === Constants.MISSING_ERROR_TYPE) {
      return groupedProblems.missing;
    }
    // Meio Fisico
    else if (this.state.currentProblemType === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return groupedProblems.attentionSignal;
    }
    else if (this.state.currentProblemType === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return groupedProblems.badSignal;
    }
    else if (this.state.currentProblemType === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return groupedProblems.capacitiveEffect;
    }
    else if (this.state.currentProblemType === Constants.NOISE_PROBLEM_TYPE) {
      return groupedProblems.noise;
    }
    else {
      return [];
    }
  }

  checkProblem = async (problem) => {
    this.solveProblem(problem, false);
  }

  solveProblem = (problem, forceSolve) => {

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "solveProblem_POST", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({
        problem: problem,
        forceSolve: forceSolve
      })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.PROBLEM_CHECKED);
        this.props.onProblemSolve(false, {});
        document.getElementById(problem._id).style.display = "none";
        this.retrieveData2();
      })
      .catch(() => {
        let message = this.singleProblemErrorMessage(problem.type) + "\n";
        alert(Strings.PROBLEM_CHECK_ERROR + Strings.REASON + message);
        this.props.onProblemSolve(false, {});
      });
  }

  singleProblemErrorMessage = (problemType) => {
    // Protocol
    if (problemType === Constants.RETRIES_ERROR_TYPE) {
      return Strings.S_RETRIES_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return Strings.S_DIAGNOSTIC_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return Strings.S_FAULT_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.ERROR_FRAME_TYPE) {
      return Strings.ERROR_FRAME_MSG;
    }
    else if (problemType === Constants.MISSING_ERROR_TYPE) {
      return Strings.S_MISSING_INITIAL_ERROR_MSG;
    }
    // Meio Fisico
    else if (problemType === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return "Não foi possível conferir o evento do dispositivo, pois o TS Monitor DN ainda está detectando que o sinal está em estado de atenção.";
    }
    else if (problemType === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return "Não foi possível conferir o evento do dispositivo, pois o TS Monitor DN ainda está detectando que o sinal está ruim.";
    }
    else if (problemType === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return "Não foi possível conferir o evento, pois o TS Monitor DN ainda está detectando efeito capacitivo.";
    }
    else if (problemType === Constants.NOISE_PROBLEM_TYPE) {
      return "Não foi possível conferir o evento, pois o TS Monitor DN ainda está detectando ruido.";
    }
    else {
      return "";
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveTagAndUptimeData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveTagAndUptimeData, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    // Só tente resolver o problema quando o solve era falso e agora for true
    if (prevProps.solveProblem.solve !== this.props.solveProblem.solve
      && this.props.solveProblem.solve === true) {
      this.checkProblem(this.props.solveProblem.problem);
    }
  }

  render() {
    return (
      <div>

        <Grid style={gridStyle} columns={3} doubling>

          <Grid.Column verticalAlign="middle" style={{ paddingBottom: "0" }}>

            <Grid columns={2}>
              <Grid.Column width={3} textAlign="center" verticalAlign="middle">
                <Popup position='bottom left' hoverable pinned wide="very"
                  trigger={
                    <Icon name="question circle" size="huge" color="teal" />
                  }>
                  <Popup.Content>
                    <p>{Strings.TS_EXPERT_POPUP_1}</p>
                    <p>{Strings.TS_EXPERT_POPUP_2_PROTOCOL}</p>
                    <p>{Strings.TS_EXPERT_POPUP_3}</p>
                    <p><b>{Strings.OBSERVATION_ABBREVIATION}: </b>{Strings.TS_EXPERT_POPUP_4}</p>
                  </Popup.Content>
                </Popup >
              </Grid.Column>
              <Grid.Column width={13} verticalAlign="middle">
                <Header style={networkTagStyle} as="h4"><b>{Strings.NETWORK_TAG}</b> {this.state.networkTag}</Header>
              </Grid.Column>
            </Grid>

          </Grid.Column>

          <Grid.Column verticalAlign="middle" textAlign="center" style={{ paddingBottom: "0" }}>
            <Button
              content={Strings.EXPORT_ACTIONS_LIST}
              color="teal"
              onClick={this.generateTsExpertReport} />

            <Dimmer page active={this.state.isGenerateReportDimmerActive} >
              <Loader size="big">{Strings.GENERATING_ACTIONS_LIST_WAITING}</Loader>
            </Dimmer>

            <PDFDownloadLink
              className="download-link"
              style={pdfLinkStyle}
              document={this.state.report}
              fileName={
                `${Strings.ACTION_LIST_TITLE} (${window.location.hostname}).pdf`
              }>
              {({ loading }) => {
                if (loading) {
                  return Strings.FINALIZING;
                }
                else {
                  if (this.state.isGenerateReportDimmerActive) {
                    let downloadLink = document.getElementsByClassName("download-link")[0];
                    downloadLink.onclick = () => {
                      setTimeout(() => {
                        if (downloadLink !== null && downloadLink !== undefined) {
                          downloadLink.innerHTML = "";
                        }
                      }, 1500);
                    };
                    this.setGeneratingDimmerState(false);
                  }
                  return Strings.SAVE_ACTION_LIST;
                }
              }}
            </PDFDownloadLink>
          </Grid.Column>

          <Grid.Column style={{ paddingBottom: "0" }}>
            <Segment style={floatStyle} size="large" compact textAlign="center">
              <Icon color="green" name="arrow alternate circle up" />
              {Strings.TIME_ON_PROTOCOL} {this.state.uptime}
            </Segment>
          </Grid.Column>

        </Grid>

        <Grid style={gridStyle} columns={2} doubling>

          <Grid.Column>
            <Segment style={leftSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.EVENTS_LIST}
              </Header>
              <Divider clearing />

              <Segment id="problems-list" style={listSegmentStyle} basic>
                <List size="medium" animated divided style={listStyle}>
                  {this.getListItem(Constants.RETRIES_ERROR_TYPE, this.state.groupedProblems.retries)}
                  {this.getListItem(Constants.DIAGNOSTIC_ERROR_TYPE, this.state.groupedProblems.diagnostic)}
                  {this.getListItem(Constants.FAULT_ERROR_TYPE, this.state.groupedProblems.fault)}
                  {this.getListItem(Constants.ERROR_FRAME_TYPE, this.state.groupedProblems.errorFrame)}
                  {this.getListItem(Constants.MISSING_ERROR_TYPE, this.state.groupedProblems.missing)}
                  {this.getListItem(Constants.ATTENTION_SIGNAL_PROBLEM_TYPE, this.state.groupedProblems.attentionSignal)}
                  {this.getListItem(Constants.BAD_SIGNAL_PROBLEM_TYPE, this.state.groupedProblems.badSignal)}
                  {this.getListItem(Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE, this.state.groupedProblems.capacitiveEffect)}
                  {this.getListItem(Constants.NOISE_PROBLEM_TYPE, this.state.groupedProblems.noise)}
                </List>
              </Segment>

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-problem-detected-header"
                as='h2'
                icon
                color="teal">
                <Icon name="check circle" color="teal" />
                {Strings.NO_PROBLEM_DETECTED}
                <Header.Subheader>
                  <p>{Strings.NO_EVENTS_TO_BE_ANALYZED}</p>
                </Header.Subheader>
              </Header>

            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment style={rightSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.ACTIONS}
              </Header>
              <Divider clearing />

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-task-selected-header"
                as="h2"
                icon
                color="teal">
                <Icon name='edit outline' color="teal" />
                {Strings.NO_EVENT_SELECTED}
                <Header.Subheader>
                  {Strings.CHOOSE_AN_EVENT}
                </Header.Subheader>
              </Header>

              <Segment id="task-details" style={taskSegmentStyle}>

                <Button
                  size="tiny"
                  circular
                  icon="times"
                  onClick={this.handleCloseButtonClick} />

                {this.getActions()}
                {this.getProblemCards()}

              </Segment>

            </Segment>

          </Grid.Column>

        </Grid>

        <div style={lastUpdateContainerStyle}>
          <div>
            <p>
              <b>{Strings.LAST_UPDATED}</b>
              {this.state.lastUpdate.toLocaleString("pt-BR")}
              {Strings.THIS_COMPUTER_TIME}
            </p>
          </div>
          <div>
            <Button
              style={{ marginLeft: "8px" }}
              circular
              color="teal"
              icon="refresh"
              onClick={this.retrieveData2} />
          </div>
        </div>

        <div id="chart" style={chartsStyle}></div>

      </div >
    );
  }
}

const mapStateToProps = state => ({
  solveProblem: state.solveProblem,
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const listStyle = {
  marginLeft: "24px",
  marginRight: "24px"
};

const leftSegmentStyle = {
  height: "66vh"
};

const rightSegmentStyle = {
  height: "66vh"
};

const listSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const taskSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const noTaskHeaderSelectedStyle = {
  marginTop: "14vh"
};

const listContentStyle = {
  marginTop: "4px",
  marginBottom: "4px"
};

const pdfLinkStyle = {
  marginLeft: "8px"
};

const networkTagStyle = {
  color: "#576577",
  marginBottom: "0"
};

const floatStyle = {
  float: "right",
  textAlign: "right"
};

const lastUpdateContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "8px"
};

const chartsStyle = {
  width: "1026px",
  height: "580px",
  display: "none",
  visibility: "hidden"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(TSExpert));
